import React, { useEffect, useState } from "react";
import { Phone } from "lucide-react";
import { SALON } from "../data/salonData";

export const FloatingCTA = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 380);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const waLink = `https://wa.me/${SALON.whatsapp}?text=${encodeURIComponent(
    "Hi Kinjal! I'd like to enquire about a service."
  )}`;

  return (
    <>
      {/* Floating WhatsApp */}
      <a
        href={waLink}
        target="_blank"
        rel="noreferrer"
        data-testid="whatsapp-fab"
        aria-label="Chat on WhatsApp"
        className={`fixed z-40 bottom-24 md:bottom-6 right-5 md:right-6 w-14 h-14 rounded-full bg-[#25D366] text-white shadow-glow flex items-center justify-center transition-all duration-500 hover:scale-110 ${
          show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
        }`}
      >
        <svg viewBox="0 0 32 32" width="26" height="26" fill="currentColor" aria-hidden="true">
          <path d="M19.11 17.32c-.27-.14-1.6-.79-1.85-.88-.25-.09-.43-.14-.61.14-.18.28-.7.88-.86 1.06-.16.18-.32.2-.59.07-.27-.14-1.13-.42-2.16-1.34-.8-.71-1.34-1.59-1.5-1.86-.16-.28-.02-.43.12-.57.13-.13.28-.32.43-.48.14-.16.18-.28.27-.46.09-.18.05-.34-.02-.48-.07-.14-.61-1.47-.84-2.02-.22-.53-.45-.46-.61-.47l-.52-.01c-.18 0-.48.07-.73.34-.25.28-.97.95-.97 2.31s.99 2.69 1.13 2.87c.14.18 1.94 2.96 4.7 4.04.66.28 1.18.45 1.58.58.66.21 1.27.18 1.75.11.53-.08 1.6-.65 1.83-1.28.23-.63.23-1.16.16-1.28-.07-.12-.25-.18-.52-.32zM16 5C9.92 5 5 9.92 5 16c0 1.95.51 3.78 1.4 5.36L5 27l5.85-1.36A10.94 10.94 0 0 0 16 27c6.08 0 11-4.92 11-11S22.08 5 16 5z" />
        </svg>
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
      </a>

      {/* Sticky mobile bottom bar */}
      <div
        data-testid="mobile-sticky-cta"
        className={`md:hidden fixed bottom-0 left-0 right-0 z-30 transition-all duration-500 ${
          show ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"
        }`}
      >
        <div className="m-3 glass-card rounded-2xl p-2 shadow-glow">
          <a
            href={`tel:${SALON.phoneTel}`}
            data-testid="mobile-cta-call"
            className="w-full inline-flex items-center justify-center gap-2 h-12 rounded-xl bg-luxuryBlack text-white font-medium text-sm"
          >
            <Phone className="w-4 h-4" /> Call {SALON.phoneDisplay}
          </a>
        </div>
      </div>
    </>
  );
};

export default FloatingCTA;
